
import Vue from 'vue'
import * as Api from '@/api/PartyIdentityUserApi'
import { PartyIdentityUserDto } from '@ViewModels/PartyIdentityUserDto'
import { Alert } from '@/components'
import { SaveButton } from '@/components/buttons'

export default Vue.extend({
   name: 'UnlockAccount',
   props: { schoolId: String, editingItem: Object as () => PartyIdentityUserDto },
   data() {
      return {
         processing: false,
         processed: false,
      }
   },
   computed: {
      locked(): boolean {
         return this.editingItem && this.editingItem.Locked
      },
   },
   methods: {
      async action() {
         try {
            this.processing = true
            await Api.unlockUserAccount(this.editingItem.Id)
            this.editingItem.Locked = false
            this.processed = true
         } finally {
            this.processing = false
         }
      },
   },
   components: {
      Alert,
      SaveButton,
   },
})
